/* Dynoforce, cookievoorkeuren vooraf aanvinken.

   Het voorkeurenvenster van Shopify opent met alles uit: personalisatie,
   marketing en analyse staan op nee tot de bezoeker ze zelf aanzet. Op
   verzoek van Luuk staan ze hier aan zodra het venster opengaat, zodat
   "Bewaar mijn keuzes" hetzelfde doet als "Alles accepteren".

   Let wel: vooraf aangevinkte hokjes voor niet-noodzakelijke cookies gelden
   onder de AVG niet als geldige toestemming (Hof van Justitie, Planet49,
   zaak C-673/17). Dat is hier een bewuste keuze, geen vergissing. Terugdraaien
   doe je door de regel in sections/df-footer.liquid te schrappen; de rest van
   de banner blijft dan gewoon werken.

   Aanvinken gebeurt met een klik op het invoerveld en niet door checked te
   zetten. Het script van Shopify houdt zijn eigen stand bij in data-consent
   op de dialoog en wisselt zelf de twee svg's; alleen checked zetten laat die
   stand op nee staan en dan bewaart de knop alsnog niets.

   De dialoog bestaat pas nadat er op Voorkeuren beheren geklikt is, vandaar
   een waarnemer in plaats van een zoekopdracht bij het laden. */

(function () {
  var VELDEN = [
    'shopify-pc__prefs__preferences-input',
    'shopify-pc__prefs__marketing-input',
    'shopify-pc__prefs__analytics-input'
  ];

  var waarnemer = null;

  function aanvinken(dialoog) {
    if (dialoog.dataset.dfVoorgevinkt) return;
    dialoog.dataset.dfVoorgevinkt = '1';
    VELDEN.forEach(function (id) {
      var el = document.getElementById(id);
      if (el && !el.checked) el.click();
    });
  }

  function kijk() {
    var d = document.getElementById('shopify-pc__prefs__dialog');
    if (!d) return;
    aanvinken(d);
    /* De dialoog wordt hergebruikt als hij opnieuw geopend wordt, dus na deze
       ene keer hoeven we niet meer mee te kijken. Sluit iemand het venster en
       opent hij het later weer, dan blijft staan wat hij zelf gekozen heeft. */
    if (waarnemer) { waarnemer.disconnect(); waarnemer = null; }
  }

  function start() {
    kijk();
    if (!waarnemer && window.MutationObserver && document.getElementById('shopify-pc__prefs__dialog') === null) {
      waarnemer = new MutationObserver(kijk);
      waarnemer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
